/* ════════════════════════════════════════════════════════════════════════════
   HTML del autodiagnóstico Pentesting Pasivo
   Se inyecta en #psq-pentest-wrap cuando se abre la herramienta.
   ════════════════════════════════════════════════════════════════════════════ */
window.psqPentestHTML = `
<div class="page active">

  <div class="psq-header">
    <h1>Pentesting pasivo de dominio o URL</h1>
    <p style="color:#64748b;font-size:13px;margin-top:6px">Análisis pasivo basado en OWASP Top 10 2025 y ASVS 4.0.3</p>
  </div>

  <!-- ═════ VISTA 1: FORMULARIO ═════════════════════════════════════════════ -->
  <div id="pg-pentest-form" class="psq-stage active">

    <div class="psq-card">
      <h3 class="psq-sec-title">¿Qué dominio o URL quieres analizar?</h3>
      <div class="psq-field">
        <label>Dominio o URL completa (obligatorio)</label>
        <input type="text" id="pt-url" placeholder="https://ejemplo.com" autocomplete="off">
      </div>
      <div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:-8px">
        <span class="psq-chip" style="cursor:pointer" onclick="psqPentestFill('https://example.com')">example.com</span>
        <span class="psq-chip" style="cursor:pointer" onclick="psqPentestFill('https://github.com')">github.com</span>
        <span class="psq-chip" style="cursor:pointer" onclick="psqPentestFill('https://mozilla.org')">mozilla.org</span>
      </div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Información del solicitante</h3>
      <div class="psq-grid2">
        <div class="psq-field">
          <label>Empresa u organización (opcional)</label>
          <input type="text" id="pt-client" placeholder="Nombre de la empresa">
        </div>
        <div class="psq-field">
          <label>Responsable (opcional)</label>
          <input type="text" id="pt-responsible" placeholder="Nombre y apellidos">
        </div>
      </div>
      <div class="psq-field">
        <label>Correo electrónico (obligatorio) *</label>
        <input type="text" id="pt-email" placeholder="correo@empresa.com">
      </div>
    </div>

    <div class="psq-disclaimer">
      <div class="psq-disclaimer-inner">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0d6efd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        <div><strong>Análisis 100% pasivo y desde tu navegador.</strong> No se realizan peticiones intrusivas ni se envía información del dominio a Zerolynx. Las consultas DNS se realizan vía DNS-over-HTTPS (Google). Algunas comprobaciones HTTP pueden no ser verificables por CORS; en ese caso se recomienda complementar con herramientas server-side como Mozilla Observatory o Qualys SSL Labs. Los resultados son orientativos y no sustituyen un pentest profesional.</div>
      </div>
    </div>

    <div id="pt-missing" class="psq-missing">Introduce un dominio o URL válida y un correo electrónico para iniciar el análisis.</div>

    <div class="psq-stage-nav">
      <button class="psq-btn psq-btn-ghost" onclick="showLanding()">← Volver</button>
      <button class="psq-btn psq-btn-primary" id="pt-start-btn" onclick="psqPentestStart()" disabled style="opacity:0.5;cursor:not-allowed;background:#6f42c1 !important">Iniciar análisis pasivo →</button>
    </div>

  </div>

  <!-- ═════ VISTA 2: ESCANEO EN CURSO ══════════════════════════════════════ -->
  <div id="pg-pentest-scanning" class="psq-stage" style="display:none">
    <div class="psq-card" style="text-align:center;padding:48px 20px">
      <div style="display:inline-block;width:40px;height:40px;border:3px solid #e5e7eb;border-top-color:#6f42c1;border-radius:50%;animation:psq-spin 0.8s linear infinite;margin-bottom:20px"></div>
      <h2 style="margin:0 0 8px;font-size:18px">Analizando <span id="pt-target-host" style="color:#6f42c1">-</span></h2>
      <p id="pt-progress-stage" style="color:#64748b;margin-bottom:20px">Inicializando análisis...</p>
      <div style="max-width:360px;margin:0 auto;height:6px;background:#e2e8f0;border-radius:3px;overflow:hidden">
        <div id="pt-progress-bar" style="height:100%;background:#6f42c1;border-radius:3px;transition:width 0.3s;width:0%"></div>
      </div>
      <p id="pt-progress-pct" style="font-size:11px;color:#94a3b8;margin-top:12px">0%</p>
    </div>
    <style>@keyframes psq-spin{to{transform:rotate(360deg)}}</style>
  </div>

  <!-- ═════ VISTA 3: RESULTADOS ════════════════════════════════════════════ -->
  <div id="pg-pentest-results" class="psq-stage" style="display:none">

    <div class="psq-toolbar">
      <button class="psq-btn psq-btn-ghost" onclick="psqPentestBack()">← Nuevo análisis</button>
      <button class="psq-btn psq-btn-primary" onclick="psqPentestExportPDF()" style="background:#6f42c1 !important">Descargar informe PDF</button>
    </div>

    <div class="psq-card">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:16px">
        <div style="flex:1;min-width:220px">
          <h2 style="margin:0 0 4px;font-size:18px">Informe de pentesting pasivo</h2>
          <p id="pt-r-target" style="font-size:13px;color:#1e293b;font-weight:600">-</p>
          <p id="pt-r-meta" style="font-size:12px;color:#64748b;margin-top:4px">-</p>
          <div style="display:flex;flex-wrap:wrap;gap:4px;margin-top:10px">
            <span class="psq-frame-tag psq-tag-iso">OWASP Top 10 2025</span>
            <span class="psq-frame-tag psq-tag-samm">OWASP ASVS 4.0.3</span>
            <span class="psq-frame-tag psq-tag-ens">CWE</span>
          </div>
        </div>
        <div class="psq-score-num">
          <div class="psq-num" id="pt-r-score" style="color:#6f42c1">0</div>
          <div class="psq-sub">/ 100</div>
          <div class="psq-lbl" id="pt-r-label" style="background:#6f42c1">Postura</div>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-top:16px">
        <div style="background:#fef2f2;border-radius:8px;padding:10px;text-align:center"><div style="font-size:22px;font-weight:800;color:#dc2626" id="pt-cnt-crit">0</div><div style="font-size:11px;color:#b91c1c">Críticos</div></div>
        <div style="background:#cff4fc;border-radius:8px;padding:10px;text-align:center"><div style="font-size:22px;font-weight:800;color:#ea580c" id="pt-cnt-alto">0</div><div style="font-size:11px;color:#087990">Altos</div></div>
        <div style="background:#fffbeb;border-radius:8px;padding:10px;text-align:center"><div style="font-size:22px;font-weight:800;color:#d97706" id="pt-cnt-medio">0</div><div style="font-size:11px;color:#055160">Medios</div></div>
        <div style="background:#d1f7eb;border-radius:8px;padding:10px;text-align:center"><div style="font-size:22px;font-weight:800;color:#16a34a" id="pt-cnt-bajo">0</div><div style="font-size:11px;color:#13795b">Bajos</div></div>
      </div>
      <div class="psq-chips" id="pt-r-chips"></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Puntuación por dominio</h3>
      <div class="psq-domain-grid" id="pt-r-domain-grid"></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Análisis radar — Postura actual vs. objetivo OWASP</h3>
      <div class="radarWrap"><canvas id="pt-radarCanvas"></canvas></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Mapeado OWASP por dominio</h3>
      <table>
        <thead><tr><th>Dominio</th><th>Puntuación</th><th>OWASP Top 10</th><th>ASVS 4.0.3</th><th>Estado</th></tr></thead>
        <tbody id="pt-r-map-tbody"></tbody>
      </table>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Hallazgos identificados</h3>
      <div id="pt-r-risk-list"></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Plan de acción priorizado</h3>
      <table>
        <thead><tr><th>#</th><th>ID</th><th>Severidad</th><th>Acción recomendada</th><th>Esfuerzo</th><th>OWASP</th></tr></thead>
        <tbody id="pt-r-action-tbody"></tbody>
      </table>
    </div>

    <p id="pt-r-footer" style="text-align:center;font-size:11px;color:#94a3b8;margin-top:12px">-</p>

  </div>

</div>
`;
